import React, { useState, useRef } from 'react';
import { useEffect } from 'react';
import Button from '@sabre/spark-react-core/button';
import Icon from '@sabre/spark-react-core/icon';
import TextInput from '@sabre/spark-react-core/text-input';
import axios from 'axios';
import { func, string } from 'prop-types';
import { ToastContainer } from 'react-toastify';
import useApi from '../../../api-wrapper/use-api.js';
import {
   URL_NEW_DISTRIBUTION_GROUP_GENERATE,
   URL_CORE_PRICING_DISTRIBUTION_FILE_UPLOAD,
   URL_NEW_DISTRIBUTION_GROUP_SEARCH,
} from '../../../end-points.js';
import { handleNonNumberKeyPress } from '../../../utils/common-util.js';
import { getApiHeaders } from '../../../utils/header-util.js';
import { NOTIFICATION_MESSAGES } from '../../../utils/notification-messages.js';
import { toastWarn } from '../../../utils/toasts.js';

const DistributionUpload = ({
   handleCancelButtonClick,
   email,
   userName,
   userId,
   handleUploadScuuess,
}) => {
   const uploadFile = useRef();
   const allowesFileType = ['csv'];
   const headers = {
      'content-type': 'multipart/form-data',
   };
   const [distributionUploadConfig, setDistributionUploadConfig] = useState({
      distributionGroupNumber: '',
      file: '',
   });
   const [
      newDistributionGroupNumberApiData,
      setNewDistributionGroupNumberApiData,
   ] = useApi({});
   const [distributionFetchApi, setDistributionFetchApi] = useApi({});
   const handleNewDistributionGroupTextChanged = (event, changedValue) => {
      if (changedValue.length <= 6) {
         setDistributionUploadConfig({
            ...distributionUploadConfig,
            distributionGroupNumber: changedValue,
         });
      } else {
         toastWarn(NOTIFICATION_MESSAGES.MAX_LENGTH_SIX_CHARS);
      }
   };

   const newDistributionGroupNumberApiCall = () => {
      setNewDistributionGroupNumberApiData({
         method: 'GET',
         url: URL_NEW_DISTRIBUTION_GROUP_GENERATE,
      });
   };
   useEffect(() => {
      if (newDistributionGroupNumberApiData.data.dgNumber) {
         if (!distributionUploadConfig.file)
            toastWarn(NOTIFICATION_MESSAGES.FILE_ATTACHMENTS_UNAVAILABLE);
         else if (
            distributionUploadConfig.file &&
            newDistributionGroupNumberApiData.data.dgNumber
         ) {
            finaluploadApiCall(
               distributionUploadConfig.file,
               newDistributionGroupNumberApiData.data.dgNumber
            );
         }
         setDistributionUploadConfig({
            ...distributionUploadConfig,
            distributionGroupNumber:
               newDistributionGroupNumberApiData.data.dgNumber,
         });
      }
   }, [newDistributionGroupNumberApiData.isLoading]);
   const handleChangeFileButtonClick = (event) => {
      const file = event?.target?.files[0];
      const fileExtension = event.target.files[0].name.split('.')[1];
      if (allowesFileType.includes(fileExtension))
         setDistributionUploadConfig({
            ...distributionUploadConfig,
            file: file,
         });
      else {
         toastWarn(NOTIFICATION_MESSAGES.INCORRECT_FILE_TYPE);
         uploadFile.current.value = '';
      }
   };

   const fileUploadApiCall = async (data) => {
      try {
         await axios({
            url: URL_CORE_PRICING_DISTRIBUTION_FILE_UPLOAD,
            method: 'POST',
            headers: getApiHeaders(headers),
            data: data,
         })
            .catch((error) => {
               toastWarn(error.message);
            })
            .then((data) => {
               handleUploadScuuess(
                  data,
                  distributionUploadConfig.distributionGroupNumber
               );
            });
      } catch (err) {
         toastWarn(err.message);
      }
   };
   const finaluploadApiCall = (file, dgNumber) => {
      const payload = {
         file: file,
         dgNumber: parseInt(dgNumber),
      };
      fileUploadApiCall(payload);
   };
   useEffect(() => {
      if (
         distributionFetchApi.data &&
         distributionFetchApi.data.length > 0 &&
         !distributionFetchApi.isLoading
      ) {
         if (!distributionUploadConfig.file)
            toastWarn(NOTIFICATION_MESSAGES.FILE_ATTACHMENTS_UNAVAILABLE);
         else if (
            distributionUploadConfig.file &&
            distributionUploadConfig.distributionGroupNumber
         )
            finaluploadApiCall(
               distributionUploadConfig.file,
               distributionUploadConfig.distributionGroupNumber
            );
      } else if (
         (distributionFetchApi.error ||
            distributionFetchApi.data.length === 0) &&
         !distributionFetchApi.isLoading &&
         distributionUploadConfig.distributionGroupNumber
      ) {
         toastWarn(NOTIFICATION_MESSAGES.INVALID_DISTRIBUTION_NUMBER);
      }
   }, [distributionFetchApi.isLoading]);
   const callDistributionFetchApi = () => {
      setDistributionFetchApi({
         method: 'POST',
         url: URL_NEW_DISTRIBUTION_GROUP_SEARCH,
         data: [
            {
               key: 'distributionGroup',
               operator: '==',
               value: distributionUploadConfig.distributionGroupNumber,
            },
         ],
      });
   };
   const handleUploadButtonClick = () => {
      if (distributionUploadConfig.distributionGroupNumber) {
         if (
            distributionUploadConfig.distributionGroupNumber.toString()
               .length === 6 &&
            distributionUploadConfig.file
         ) {
            callDistributionFetchApi();
         } else if (
            distributionUploadConfig.distributionGroupNumber.toString().length <
            6
         )
            toastWarn(NOTIFICATION_MESSAGES.MAX_LENGTH_SIX_CHARS);
         else if (!distributionUploadConfig.file)
            toastWarn(NOTIFICATION_MESSAGES.FILE_ATTACHMENTS_UNAVAILABLE);
      } else {
         newDistributionGroupNumberApiCall();
      }
   };
   return (
      <div className='distribution-upload-root'>
         <div className='row'>
            <ToastContainer autoClose={3000} hideProgressBar theme='colored' />
            <div
               className='spark-bold spark-large'
               data-testid='dg-upload-title-id'
            >
               Distribution Group Upload
            </div>
         </div>
         <div className='row spark-flex spark-mar-t-1 spark-pad-.5 distribution-info-panel'>
            <div className=' spark-flex distribution-info-icon-circle alignment-center'>
               <Icon
                  name='alert-triangle'
                  size='md'
                  style='fill'
                  label='alert'
               />
            </div>
            <div
               className='spark-mar-l-1 distribution-upload-root-alert-text'
               data-testid='dg-upload-alert-text-id'
            >
               Alert information pane
            </div>
         </div>
         <div className='row spark-flex spark-mar-t-1 spark-pad-.5 distribution-info-panel'>
            <div className='distribution-info-icon-circle distribution-upload-root-general-text'></div>
            <div
               className='spark-mar-l-1 distribution-upload-root-alert-text distribution-upload-root-general-text-color'
               data-testid='dg-upload-general-text-id'
            >
               General information pane
            </div>
         </div>
         <div className='row spark-mar-top-2 spark-bold'>
            <div
               className='distribution-label'
               data-testid='dg-upload-dg-number-text-id'
            >
               Distribution Group
            </div>
            <TextInput
               data-testid='dg-upload-dg-number-id'
               onKeyPress={(event) => handleNonNumberKeyPress(event)}
               value={distributionUploadConfig.distributionGroupNumber}
               onChange={(event, changedValue) =>
                  handleNewDistributionGroupTextChanged(event, changedValue)
               }
            />
         </div>
         <div className='row spark-pad-t-2'>
            <input
               ref={uploadFile}
               type='file'
               accept='.csv'
               data-testid='dg-upload-file-attachment-id'
               required
               onChange={handleChangeFileButtonClick}
            />
         </div>
         <div className='row spark-flex spark-pad-t-2 alignment-right'>
            <Button
               name='dg-cancel-button'
               className='spark-btn--secondary spark-mar-r-1'
               size={Button.SIZE.SMALL}
               onClick={handleCancelButtonClick}
            >
               CANCEL
            </Button>
            <Button
               name='dg-upload-button'
               className='spark-btn--primary'
               size={Button.SIZE.SMALL}
               onClick={handleUploadButtonClick}
            >
               UPLOAD
            </Button>
         </div>
      </div>
   );
};
DistributionUpload.prototype = {
   handleCancelButtonClick: func,
   handleUploadScuuess: func,
   userName: string,
   email: string,
   userId: string,
};
export default DistributionUpload;
